// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DropdownQuestion_wrapper__23dhW"};